import { createSelector } from '@reduxjs/toolkit'

import { makeFetchSelectors } from 'app/redux-fetch/selectors'
import type { ProfileData } from './types'
import {
  PROFILES_LIST_REDUCER_NAME,
  PROFILES_REDUCER_NAME,
} from 'features/profiles/consts'
import { EDGE_PROFILES_URL } from 'app/consts'
import { rootDomainsDataSelector } from 'features/rootDomains/selectors'

export const profilesSelector = makeFetchSelectors(
  PROFILES_REDUCER_NAME,
  PROFILES_LIST_REDUCER_NAME
)

export const profilesListSelector = createSelector(
  profilesSelector.data,
  (profilesData) => {
    const profiles = profilesData || []

    return profiles.map((profile: ProfileData) => ({
      id: profile.profile_id,
      name: profile.profile_name,
      thumbnail: `${EDGE_PROFILES_URL}/${profile.display_name}/image`,
      manufacturer: profile.manufacturer,
      model: profile.model,
      deviceClass: profile.device_class,
      uploaded: profile.last_updated,
      version: profile.version,
      downloadLink: profile.profile_url,
    }))
  }
)

export const profilesListIsFetchingSelector = createSelector(
  [rootDomainsDataSelector.isFetching, profilesSelector.isFetching],
  (rootDomainIsFetching, profilesListIsFetching) =>
    rootDomainIsFetching || profilesListIsFetching
)

export const profilesListErrorSelector = createSelector(
  [rootDomainsDataSelector.error, profilesSelector.error],
  (rootDomainError, profilesListError) => rootDomainError || profilesListError
)

export const profilesListIsFinishedSelector = createSelector(
  [rootDomainsDataSelector.isFinished, profilesSelector.isFinished],
  (rootDomainIsFinished, profilesListIsFinished) =>
    rootDomainIsFinished && profilesListIsFinished
)
